import React from "react";
export const SearchTextContext = React.createContext({});
